import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { WHATSAPP_NUMBER, WH_LINK } from 'shared/constants'
import { openExternalUrl } from 'shared/lib/external-open'

import s from './styles.module.scss'

export const SupportContact = () => {
  const { t } = useTranslation()

  const handleSupportClick = () => {
    openExternalUrl(`${WH_LINK}${WHATSAPP_NUMBER}`)
  }

  return (
    <p className={clsx('medium-12', s.text)}>
      {t('kyrgyzstan_block.my_objects.support.prefix')}{' '}
      <button
        type="button"
        className={clsx('medium-12', s.link)}
        onClick={handleSupportClick}
      >
        {t('kyrgyzstan_block.my_objects.support.write')}
      </button>
    </p>
  )
}
